<template>
  <el-table :data="data" style="width: 100%;" :row-class-name="tableRowClassName" height="calc(100% - 140px)">
    <el-table-column label="序号" type="index" width="80">
    </el-table-column>
    <el-table-column prop="UserCode" label="客户代码">
    </el-table-column>
    <el-table-column prop="UserName" label="客户名称">
    </el-table-column>
    <el-table-column prop="CommodityNo" label="品种代码">
    </el-table-column>
    <el-table-column prop="CommodityName" label="品种名称">
    </el-table-column>
    <el-table-column prop="IB" label="层级关系" :show-overflow-tooltip="true">
    </el-table-column>
    <el-table-column prop="Volume" label="单量">
    </el-table-column>
    <el-table-column prop="CloseProfit" label="平盈">
    </el-table-column>
    <el-table-column prop="Commission" label="手续费">
    </el-table-column>
    <!-- 查看明细弹窗 -->
  </el-table>
</template>

<script>
import EnumConfig from "../../../../assets/js/EnumConfig.js";
export default {
  // 委托表格
  name: "mycapitalT",
  data() {
    return {
      dialogVisible: false,
      obj: {}
    };
  },
  props: ["data"],
  filters: {
    GetDelegateOrderStateType(type) {
      return EnumConfig.GetDelegateOrderStateType(type);
    },
    GetDirection(type) {
      return EnumConfig.GetDirection(type);
    },
    PositionEffect(type) {
      return EnumConfig.PositionEffect(type);
    }
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    handleClick(row) {
      this.dialogVisible = true;
      this.obj = row;
    }
  }
};
</script>

<style scoped>
</style>
 


// WEBPACK FOOTER //
// src/components/selects/staticsToday/StatisticsOrder/StatisticsOrderT.vue